<div *ngIf="extraUpsell" class="upsell-popup-holder">
  <ng-container *ngTemplateOutlet="upsellPopover"></ng-container>
</div>
<div class='ingredient primary-bg-color' #ingredientWrap [ngClass]="{'flex-wrap': hasTags}">
  <div class="label-wrapper" [ngClass]="{'d-flex flex-column': orderedIngredient && (ingredient.qualifiers?.length || ingredient.allowHalves) && hasTags, 'with-tags': hasTags}">
    <fts-themeable-checkbox
        *ngIf="!choice.needsSingleIngredientSelection"
        [ngModel]='themableCheckBoxInitialValue'
        [ingredient]='true'
        [name]='ingredient.name'
        (ngModelChange)='toggleIngredient($event)'
        [waitForConfirmation]="ingredient?.acknowledgeRemovedDefaults"
        [needsMaxIngredientsWarningsCheck]="needsMaxIngredientsWarningsCheck"
        class='full-width ingredient-checkbox'
        [ariaLabel]="ingredient.name + (isDisabled ? ('component.item_editor.choice.ingredient.ingredient_card.disabled' | translate): '')"
        [disabled]='isDisabled'
        [isInModal]="isInModal"
        [isUnavailable]='isUnavailable'
        [storeConfig]="storeConfig"
        (click)="onIngredientClick()"
        [isHalfAndHalf]="isHalfAndHalf">
        <fts-ingredient-info
          [ingredient]='ingredient'
          [ingredientPrice]="orderedIngredient?.price"
          [isInModal]="isInModal"
          [ingredientIndex]="ingredientIndex"
          [showIngredientPrices]='choice.showIngredientPrices'
          [isUnavailable]='isUnavailable'
          [itemSize]='itemSize'
          [isHalf]='orderedIngredient?.isLeftHalf || orderedIngredient?.isRightHalf || (isHalfAndHalf && ingredient.allowHalves)'
          [isHalfAndHalf]="isHalfAndHalf"
          [isHalfSelected]="!!orderedIngredient"
          [orderedQualifiers]='orderedIngredient?.qualifiers'
          [orderedSecondQualifiers]='orderedIngredient?.secondHalfQualifiers'
          [storeConfig]="storeConfig"
          [inItemEditorModal]="inItemEditorModal">
        </fts-ingredient-info>
     </fts-themeable-checkbox>

    <div class="radio-wrapper full-width" [ngClass]="{'full-height': orderedIngredient && (ingredient.qualifiers?.length || ingredient.allowHalves) && hasTags}" *ngIf='choice.needsSingleIngredientSelection'>
      <fts-themeable-radio [name]='choice.name'
                           [ngModel]="singleSelectionChoiceSelectedIngredient?.ingredient"
                           [value]='ingredient.name'
                           [fullWidth]='true'
                           [ingredient]='true'
                           [isInModal]="isInModal"
                           [disabled]='isDisabled'
                           [isUnavailable]='isUnavailable'
                           [singleDefaultName]="singleDefaultName"
                           [storeConfig]="storeConfig"
                           [calories]="calories"
                           [servings]="servings"
                           [displayedIngredientPrice]="displayedIngredientPrice"
                           [availableSizes]="availableSizes"
                           (ngModelChange)='toggleIngredient($event)'
                           (click)="onIngredientClick()">
        <fts-ingredient-info
          [ingredient]='ingredient'
          [ingredientPrice]="orderedIngredient?.price"
          [isInModal]="isInModal"
          [ingredientIndex]="ingredientIndex"
          [showIngredientPrices]='choice.showIngredientPrices'
          [isUnavailable]='isUnavailable'
          [itemSize]='itemSize'
          [isHalf]='orderedIngredient?.isLeftHalf || orderedIngredient?.isRightHalf'
          [orderedQualifiers]='orderedIngredient?.qualifiers'
          [storeConfig]="storeConfig"
          [isRadioButton]="true"
          [isHalfAndHalf]="isHalfAndHalf"
          [isHalfSelected]="!!orderedIngredient"
          [inItemEditorModal]="inItemEditorModal"
          (onCaloriesCalc)="onCaloriesCalc($event)"
          (onServingsCalc)="onServingsCalc($event)"
          (onDisplayedIngredientPriceCalc)="onDisplayedIngredientPriceCalc($event)"
          (onAvailableSizesCalc)="onAvailableSizesCalc($event)">
        </fts-ingredient-info>
      </fts-themeable-radio>
    </div>

    <ng-container [ngTemplateOutlet]="((orderedIngredient && (ingredient.qualifiers?.length || ingredient.allowHalves)) && hasTags) ? ingredientTags : null"></ng-container>
  </div>

  <div class="halves-container" *ngIf="orderedIngredient && (ingredient.qualifiers?.length || ingredient.allowHalves)" [ngClass]="{'has-second-half': showSecondHalves, 'with-tags': hasTags}">

    <div class="half-extra-wrapper" *ngIf="!!orderedIngredient">
      <div class="halves" *ngIf='ingredient.allowHalves && !isHalfAndHalf'>
        <div class='ingredient-halves' [@scaleX]
            [ngClass]="{'disabled': isDisabled}">
          <button class="half left btn-nostyle"
              [attr.aria-pressed]="orderedIngredient?.isLeftHalf"
              [attr.aria-label]="'component.item_editor.choice.ingredient.ingredient_card.left_half' | translate"
              [ngClass]="{
                'selection-bg-color': orderedIngredient?.isLeftHalf,
                'excluded': orderedIngredient?.isRightHalf && !ingredient?.allowSecondHalves
              }"
              (click)='selectHalf(true, false)'>
              <fa-icon class="excluded-icon full-width" *ngIf="orderedIngredient?.isRightHalf && !ingredient?.allowSecondHalves" [icon]="faTimes" [size]="'xs'"></fa-icon>
          </button>
          <button class="half whole btn-nostyle"
              [id]="'first-half-whole-' + orderedIngredient.ingredient"
              [attr.aria-pressed]="orderedIngredient && !orderedIngredient.isLeftHalf && !orderedIngredient.isRightHalf"
              [attr.aria-label]="'component.item_editor.choice.ingredient.ingredient_card.whole' | translate"
              [ngClass]="{'selection-bg-color': orderedIngredient && !orderedIngredient.isLeftHalf && !orderedIngredient.isRightHalf}"
              (click)='selectHalf(false, false)'>
          </button>
          <button class="half right btn-nostyle"
              [attr.aria-pressed]="orderedIngredient?.isRightHalf"
              [attr.aria-label]="'component.item_editor.choice.ingredient.ingredient_card.right_half' | translate"
              [ngClass]="{
                'selection-bg-color': orderedIngredient?.isRightHalf,
                'excluded': orderedIngredient?.isLeftHalf && !ingredient?.allowSecondHalves
              }"
              (click)='selectHalf(false, true)'>
              <fa-icon class="excluded-icon full-width" *ngIf="orderedIngredient?.isLeftHalf && !ingredient?.allowSecondHalves" [icon]="faTimes" [size]="'xs'"></fa-icon>
          </button>
        </div>
      </div>

      <fts-qualifier-choice
        *ngIf='ingredient.qualifiers?.length && !isDisabledQualifier'
        class='ingredient-qualifiers'
        [ngClass]="{'margin-top-10': !ingredient.allowHalves || isHalfAndHalf}"
        [orderedQualifiers]='qualifiers'
        [qualifiers]='ingredient.qualifiers'
        [visible]='!!this.orderedIngredient'
        [size]='itemSize'
        [ingredientIndex]="ingredientIndex"
        [isInModal]="isInModal"
        [isHalf]='orderedIngredient?.isLeftHalf || orderedIngredient?.isRightHalf'
        [popoverContextEl]="ingredientWrapRef"
        [inItemEditorModal]="inItemEditorModal"
        (qualifierChange)='toggleQualifier($event)'
        [isHalfAndHalf]="isHalfAndHalf"
        [hideInHalfAndHalf]="!themableCheckBoxInitialValue"
      ></fts-qualifier-choice>
    </div>

    <ng-container *ngIf="!isHalfAndHalf" [ngTemplateOutlet]="showSecondHalves ? secondHalfTemplate : null"></ng-container>

    </div>

    <ng-container [ngTemplateOutlet]="((!orderedIngredient || (orderedIngredient && !ingredient.qualifiers?.length && !ingredient.allowHalves)) && hasTags) ? ingredientTags : null"></ng-container>
</div>

<ng-template #upsellPopover>
  <div #popoverRef class="upsell-info action-bg-color text-center" tabindex="-1" [ngClass]="{'in-modal': inItemEditorModal && !(breakPointService.isTabletDown$ | async)}">
    <div class="text-container">
      <span class="action-inverse-text-color">
        <b><u>{{extraUpsell?.qualifier?.name}}</u></b> {{extraUpsell?.ingredient}}
        {{'component.item_editor.choice.ingredient.ingredient_card.for_only' | translate}}
        {{extraUpsell?.priceDiff | currency:'USD':'symbol'}}
        {{'component.item_editor.choice.ingredient.ingredient_card.more' | translate}}
      </span>
    </div>
    <div class="button-container">
      <button class='btn action-inverse-border-color ingredient-qualifier-btn font-secondary margin-5'
              (click)="toggleQualifier(extraUpsell?.qualifier, true)">
        <span class="action-inverse-text-color" translate>component.item_editor.choice.ingredient.ingredient_card.add_it</span>
      </button>
      <button class="btn btn-link btn-undecorated padding-0 margin-5" (click)="denyExtraUpsell()">
        <span class="action-inverse-text-color font-secondary" translate>component.item_editor.choice.ingredient.ingredient_card.no_thanks</span>
      </button>
    </div>
    <div class="popover-arrow" [ngClass]="{'in-modal': inItemEditorModal && !(breakPointService.isTabletDown$ | async)}">
      <fa-icon *ngIf="!inItemEditorModal || (inItemEditorModal && (breakPointService.isTabletDown$ | async))" [icon]="faCaretDown" size="2x" class="action-text-color"></fa-icon>
      <fa-icon *ngIf="inItemEditorModal && !(breakPointService.isTabletDown$ | async)" [icon]="faCaretUp" size="2x" class="action-text-color"></fa-icon>
    </div>
  </div>
</ng-template>

<ng-template #secondHalfTemplate>
  <div class="half-extra-wrapper">
    <div class="halves" *ngIf='ingredient.allowHalves'>
      <div class='ingredient-halves' [@scaleX]
          [ngClass]="{'disabled': isDisabled}">
        <button class="half left btn-nostyle"
            [attr.aria-pressed]="orderedIngredient?.isRightHalf"
            (click)="selectHalf(false, true, true)"
            [attr.aria-label]="'component.item_editor.choice.ingredient.ingredient_card.second_left_half' | translate"
            [ngClass]="{
              'selection-bg-color': orderedIngredient?.isRightHalf && orderedIngredient?.secondHalfQualifiers?.length,
              'excluded': orderedIngredient?.isRightHalf && !orderedIngredient?.secondHalfQualifiers?.length
            }">
            <fa-icon class="excluded-icon full-width" *ngIf="orderedIngredient?.isRightHalf && !orderedIngredient?.secondHalfQualifiers?.length" [icon]="faTimes" [size]="'xs'"></fa-icon>
        </button>
        <button class="half whole btn-nostyle"
            [attr.aria-pressed]="!orderedIngredient?.isLeftHalf && !orderedIngredient?.isRightHalf"
            [attr.aria-label]="('component.item_editor.choice.ingredient.ingredient_card.second_half_whole' | translate)"
            (click)='selectHalf(false, false, true)'> 
        </button>
        <button class="half right btn-nostyle"
            [attr.aria-pressed]="orderedIngredient?.isLeftHalf"
            (click)="selectHalf(true, false, true)"
            [attr.aria-label]="'component.item_editor.choice.ingredient.ingredient_card.second_right_half' | translate"
            [ngClass]="{
              'selection-bg-color': orderedIngredient?.isLeftHalf && orderedIngredient?.secondHalfQualifiers?.length,
              'excluded': orderedIngredient?.isLeftHalf && !orderedIngredient?.secondHalfQualifiers?.length
            }">
            <fa-icon class="excluded-icon full-width" *ngIf="orderedIngredient?.isLeftHalf && !orderedIngredient?.secondHalfQualifiers?.length" [icon]="faTimes" [size]="'xs'"></fa-icon>
        </button>
      </div>
    </div>

    <fts-qualifier-choice
      *ngIf="ingredient.qualifiers?.length && !isDisabled"
      class="ingredient-qualifiers"
      [ngClass]="{'margin-top-10': !ingredient.allowHalves}"
      [orderedQualifiers]="orderedIngredient?.secondHalfQualifiers"
      [qualifiers]="ingredient.qualifiers"
      [visible]="!!this.orderedIngredient"
      [size]="itemSize"
      [ingredientIndex]="ingredientIndex"
      [isInModal]="isInModal"
      [isHalf]="true"
      [isSecondHalf]="true"
      [popoverContextEl]="ingredientWrapRef"
      [inItemEditorModal]="inItemEditorModal"
      (qualifierChange)="toggleSecondQualifier($event)"
    ></fts-qualifier-choice>
  </div>
</ng-template>

<ng-template #ingredientTags>
  <div class="ingredient-tag-wrapper">
    <fts-ingredient-tags 
      [ingredient]="ingredient"  
      (tagClicked)="tagClicked.emit($event)"></fts-ingredient-tags>
  </div>
</ng-template>
